var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MdSwitch',{class:[_vm.disabled ? '' : 'md-primary'],attrs:{"value":!_vm.status,"disabled":_vm.disabled},on:{"change":_vm.onToggle}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }